import { render, staticRenderFns } from "./ProjectsDropdown.vue?vue&type=template&id=4899b1b2&scoped=true&"
import script from "./ProjectsDropdown.vue?vue&type=script&lang=js&"
export * from "./ProjectsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsDropdown.vue?vue&type=style&index=0&id=4899b1b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4899b1b2",
  null
  
)

export default component.exports